import * as Constants from '../Constant';

const initialState = {
    message: {},
    treatments: {},
    invoice: [],
    allInvoices: [],
}

export default function billingReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.GET_TREATMENT_BY_ID:
            return {
                ...state,
                treatments: action.payload,
            }
        case Constants.CREATE_BILL:
            return {
                ...state,
                message: action.payload,
            }
        case Constants.GET_INVOICE:
            return {
                ...state,
                invoice: action.payload,
            }
        case Constants.GET_ALL_INVOICES:
            return {
                ...state,
                allInvoices: action.payload,
            }
        case Constants.RESET:
            return {
                ...initialState,
            }
        default:
            return state;
    }
}